import { useAppSelector } from '../store/hooks'
import './AssessmentScreen.css'

function AssessmentScreen() {
  const { appName, appDescription } = useAppSelector((state) => state.request)

  return (
    <div className="assessment-screen" data-testid="assessment-screen">
      <section className="assessment-screen__summary" data-testid="assessment-summary" aria-labelledby="assessment-summary-heading">
        <h2 className="assessment-screen__summary-title" id="assessment-summary-heading">Request Summary</h2>

        <dl className="assessment-screen__summary-list">
          <div className="assessment-screen__summary-field">
            <dt className="assessment-screen__summary-label">App Name:</dt>
            <dd className="assessment-screen__summary-value" data-testid="assessment-summary-name">
              {appName}
            </dd>
          </div>

          <div className="assessment-screen__summary-field">
            <dt className="assessment-screen__summary-label">Description:</dt>
            <dd
              className="assessment-screen__summary-value"
              data-testid="assessment-summary-description"
            >
              {appDescription}
            </dd>
          </div>
        </dl>
      </section>

      <section className="assessment-screen__progress" data-testid="assessment-progress" aria-labelledby="assessment-progress-heading">
        <h3 className="assessment-screen__progress-title" id="assessment-progress-heading">
          Assessing Request against Policy &amp; Technical Criteria...
        </h3>

        <div
          className="assessment-screen__progress-bar-track"
          role="progressbar"
          aria-label="Assessment progress"
          aria-valuetext="Assessment in progress"
        >
          <div className="assessment-screen__progress-bar-fill" data-testid="assessment-progress-bar-fill" />
        </div>

        <p className="assessment-screen__progress-message">
          Please wait while we review your request. This typically takes a few moments.
        </p>

        <div className="assessment-screen__spinner" data-testid="assessment-spinner" role="status" aria-label="Assessing request">
          <span className="sr-only">Assessing request...</span>
        </div>
      </section>
    </div>
  )
}

export default AssessmentScreen
